export const getCurrentLocale = () => import.meta.env.VITE_LANG_DEFAULT

export const getFallbackLocale = () =>
  import.meta.env.VITE_LANG_DEFAULT === 'en-US' ? 'zh-CN' : 'en-US'
